export enum PackageType {
  CREATORES = "CREATORES",
  TEAMS = "TEAMS",
  CUSTOM = "CUSTOM",
  TRIAL = "TRIAL",
}
